import { getActivePinia } from 'pinia';
import type { Pinia, Store } from 'pinia';

/**
 * 重置 store 的統一入口。
 *
 * reset() 由各 store 自行實作；沒有實作的會被 storeAutoResetPlugin 自動補上一份
 * （還原成初始 state），所以正常情況下不會有 store 被跳過。
 * 下面的 warn 只在 plugin 沒註冊到（例如測試環境自建 pinia）時才會出現。
 */

interface ExtendedPinia extends Pinia {
  _s: Map<string, Store>;
}

// 定義 store 的 reset 方法型別
type StoreWithReset = Store & {
  reset?: () => void;
};

export function useResetStore() {
  const pinia = getActivePinia() as ExtendedPinia;

  if (!pinia) {
    throw new Error('There is no active Pinia instance');
  }

  const resetStore: Record<string, () => void> = {};

  for (const [name, store] of pinia._s) {
    resetStore[name] = () => {
      const storeWithReset = store as StoreWithReset;

      // 直接使用手動實作的 reset() 方法
      if (typeof storeWithReset.reset === 'function') {
        storeWithReset.reset();
      } else {
        console.warn(`Store "${name}" does not have a reset method`);
      }
    };
  }

  resetStore.all = () => {
    for (const [name, store] of pinia._s) {
      const storeWithReset = store as StoreWithReset;

      // 直接使用手動實作的 reset() 方法
      if (typeof storeWithReset.reset === 'function') {
        storeWithReset.reset();
      } else {
        console.warn(`Store "${name}" does not have a reset method`);
      }
    }
  };
  return resetStore as typeof resetStore & { all: () => void };
}
